module.exports = __webpack_public_path__ + "static/media/infoBlack.b33d4613.svg";